if (!customElements.get("affirm-logo-message")) {
  class AffirmLogoMessage extends HTMLElement {
    constructor() {
      super();
      this.position = this.dataset.position;
      this.debounceTimer = null;
      this.observer = null;

      this.onShopifySectionLoad = this.onShopifySectionLoad.bind(this);
      this.onLiquidAjaxCartQueueEnd = this.onLiquidAjaxCartQueueEnd.bind(this);
    }

    connectedCallback() {
      this.initListeners();
      this.observeSellingPlanChange();
      this.observeUrlChange();
      this.updateVisibility();
    }

    initListeners() {
      document.addEventListener("shopify:section:load", this.onShopifySectionLoad);

      if (this.position === "cart") {
        // Refresh only once after the whole Liquid Ajax Cart queue finishes.
        // This prevents multiple refresh calls when multiple variants are added in a single flow.
        document.addEventListener("liquid-ajax-cart:queue-end", this.onLiquidAjaxCartQueueEnd);
      }
    }

    onShopifySectionLoad() {
      this.refreshAffirmUI();
    }

    onLiquidAjaxCartQueueEnd() {
      if (this.position !== "cart") return;
      this.debounce(() => this.refreshAffirmUI(), 500);
    }

    getElements() {
      const sellingPlanInput = document.querySelector('input.selected-selling-plan-id[name="selling_plan"]');
      const affirmContainer = this.querySelector(".affirm-as-low-as.product-page-affirm");
      return { sellingPlanInput, affirmContainer };
    }

    hasSellingPlanInUrl() {
      const params = new URLSearchParams(window.location.search);
      return params.has("selling_plan");
    }

    updateVisibility() {
      const { sellingPlanInput, affirmContainer } = this.getElements();
      if (!affirmContainer) return;

      // Case 1: Selling plan input exists (normal PDP behavior)
      if (sellingPlanInput) {
        const isOneTimePurchase = !sellingPlanInput.value;
        affirmContainer.style.display = isOneTimePurchase ? "block" : "none";
        return;
      }

      // Case 2: No selling plan input — fallback to URL inspection
      const hasSellingPlan = this.hasSellingPlanInUrl();
      affirmContainer.style.display = hasSellingPlan ? "block" : "none";
    }

    observeSellingPlanChange() {
      const { sellingPlanInput } = this.getElements();
      if (!sellingPlanInput) return;

      this.observer = new MutationObserver(() => {
        this.updateVisibility();
      });

      this.observer.observe(sellingPlanInput, {
        attributes: true,
        attributeFilter: ["value"],
      });
    }

    observeUrlChange() {
      const update = () => this.updateVisibility();

      window.addEventListener("popstate", update);

      const pushState = history.pushState;
      const replaceState = history.replaceState;

      history.pushState = function () {
        pushState.apply(history, arguments);
        update();
      };

      history.replaceState = function () {
        replaceState.apply(history, arguments);
        update();
      };
    }

    debounce(fn, delay = 500) {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(fn, delay);
    }

    refreshAffirmUI() {
      if (window.affirm && window.affirm.ui) {
        window.affirm.ui.refresh();
      } else {
        console.warn("[AffirmLogoMessage] Affirm SDK not loaded yet.");
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();

      document.removeEventListener("shopify:section:load", this.onShopifySectionLoad);
      document.removeEventListener("liquid-ajax-cart:queue-end", this.onLiquidAjaxCartQueueEnd);
    }
  }

  customElements.define("affirm-logo-message", AffirmLogoMessage);
}